// src/utils/stories.js
import api from "../api";


// NEW: global, cursor-paginated list of active story owners
export async function fetchActiveStoryUsers({ cursor = 0, limit = 200 } = {}) {
  const { data } = await api.get('/stories/active-users', {
    params: { cursor, limit }
  });
  // shape: { cursor, nextCursor, count, users: [{ userId, username, ... }] }
  return data;
}


/**
 * Fetch paginated story feed for the swipe viewer.
 * Query supports: cursor, limit, following, merchants, country, lang, scope
 * Returns: { items: [...], nextCursor: string|null }
 */
export async function fetchStoryFeed(opts = {}) {
  const params = new URLSearchParams();
  Object.entries(opts).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") params.set(k, v);
  });
  const { data } = await api.get(`/stories/feed/v2?${params.toString()}`);
  return data;
}

/**
 * Ensure the current user (me) is the first item in the discovery list,
 * preserving everyone else’s order. If the user isn’t present, inject them.
 */
export function ensureSelfFirst(discoveryUsers = [], me) {
  if (!me) return Array.isArray(discoveryUsers) ? discoveryUsers : [];

  const uname = me.username;
  let selfEntry = null;
  const others = [];

  for (const u of discoveryUsers || []) {
    if (!u) continue;
    const isSelf = u._id === me._id || u.username === uname;
    if (isSelf) {
      // Prefer the version that actually has latestStory
      if (!selfEntry || (!!u.latestStory && !selfEntry.latestStory)) {
        selfEntry = u;
      }
    } else {
      others.push(u);
    }
  }

  // If self wasn't in the list at all, inject a minimal record (uncertain)
  if (!selfEntry) {
    selfEntry = {
      _id: me._id,
      username: uname,
      name: me.name || uname,
      profilePic: me.profilePic || me.avatar || "",
      latestStory: me.latestStory ?? null,
      isSelf: true,
      _injected: true, // mark as we don't know story status for sure
    };
  }

  return [selfEntry, ...others];
}

/**
 * De-duplicate by _id while keeping the first occurrence’s order.
 */
export function dedupeById(arr) {
  const seen = new Set();
  const out = [];
  for (const item of arr || []) {
    if (!item || !item._id) continue;
    if (!seen.has(item._id)) {
      seen.add(item._id);
      out.push(item);
    }
  }
  return out;
}
